module.exports = __webpack_public_path__ + "static/12-funding-fd0c48252c8a741f653d6458c5cabb25.png";